// @ts-nocheck
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
// Tambahkan modul ke Swiper
Swiper.use([Autoplay, Navigation, EffectFade, Pagination]);

export function initHeroHomeSwiper() {
    const sliderRoom = new Swiper('.slider-room', {
        loop: false,
        speed: 1500,
        spaceBetween: 40,
        slidesPerView: 1,
        navigation: {
            nextEl: '.nav-slider-room .btn-next',
            prevEl: '.nav-slider-room .btn-prev',
        },
        breakpoints: {
            430: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1.8,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 1.8,
                spaceBetween: 40,
            },
        },
    });

    const sliderImgRoom = new Swiper('.slider-img-room', {
        effect: "fade",
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-img-room .btn-next',
            prevEl: '.nav-slider-img-room .btn-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
    });

    const sliderHighlightTitle = new Swiper('.slider-highlight-title', {
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-highlight .btn-next',
            prevEl: '.nav-slider-highlight .btn-prev',
        },
        allowTouchMove: false,
    });
    
    const sliderHighlightImg = new Swiper('.slider-highlight-img', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-highlight .btn-next',
            prevEl: '.nav-slider-highlight .btn-prev',
        },
        allowTouchMove: false,
    });

    const sliderOffers = new Swiper('.slider-offers', {
        loop: true,
        speed: 1500,
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: {
            nextEl: '.nav-slider-offers .btn-next',
            prevEl: '.nav-slider-offers .btn-prev',
        },
        breakpoints: {
            430: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

    const sliderAward = new Swiper('.slider-award', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-award .btn-next',
            prevEl: '.nav-slider-award .btn-prev',
        },
    });

    const sliderOtherRoom = new Swiper('.slider-other-room', {
        loop: false,
        speed: 1500,
        spaceBetween: 40,
        slidesPerView: 1,
        navigation: {
            nextEl: '.nav-slider-room .btn-next',
            prevEl: '.nav-slider-room .btn-prev',
        },
        breakpoints: {
            430: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });

    const sliderEventHeader = new Swiper('.slider-event-header', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-event .btn-next',
            prevEl: '.nav-slider-event .btn-prev',
        },
        // allowTouchMove: false,
    });

    const sliderEventImg = new Swiper('.slider-event-img', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1000,
        // navigation: {
        //     nextEl: '.nav-slider-event .btn-next',
        //     prevEl: '.nav-slider-event .btn-prev',
        // },
        // allowTouchMove: false,
    });

    const sliderEventText = new Swiper('.slider-event-text', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 1000,
        // navigation: {
        //     nextEl: '.nav-slider-event .btn-next',
        //     prevEl: '.nav-slider-event .btn-prev',
        // },
        // allowTouchMove: false,
    });

    const sliderHeroWedding = new Swiper(".slider-hero-wedding", {
        effect: "fade",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        centeredSlides: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
            },
            1024: {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
            },
        },
    });

    const mySwiperPopup = new Swiper(".mySwiperPopup", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 1000,
        centeredSlides: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });


    const sliderSpaReview = new Swiper('.slider-spareview', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        navigation: {
            nextEl: '.nav-slider-spareview .btn-next',
            prevEl: '.nav-slider-spareview .btn-prev',
        },
    });

    // Sinkronkan 3 slider sliderEventText,Img,Header
    let isSyncing = false;

    function syncSliderEvent(from, index) {
        if (isSyncing) return;
        isSyncing = true;

        if (from !== 'header') sliderEventHeader.slideTo(index);
        if (from !== 'img') sliderEventImg.slideTo(index);
        if (from !== 'text') sliderEventText.slideTo(index);

        setTimeout(() => {
            isSyncing = false;
        }, 100);
    }

    // masing-masing trigger sync, tapi diberi asalnya (untuk mencegah loop)
    sliderEventHeader.on('slideChange', () => {
        syncSliderEvent('header', sliderEventHeader.realIndex);
    });

    sliderEventImg.on('slideChange', () => {
        syncSliderEvent('img', sliderEventImg.realIndex);
    });

    sliderEventText.on('slideChange', () => {
        syncSliderEvent('text', sliderEventText.realIndex);
    });

}